import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { api } from './lib/api';
import { AuthProvider } from './context/AuthContext';
import AuthModal from './components/AuthModal';
import { Toaster } from 'sonner';
import HomePage from './pages/HomePage';
import ElevePage from './pages/ElevePage';
import EnseignantPage from './pages/EnseignantPage';
import LivretPage from './pages/LivretPage';
import { MagazineIndexPage, ArticlePage } from './pages/MagazinePages';
import { AdminArticlesList, AdminArticleEditor } from './pages/AdminPages';
import AdminDashboardPage from './pages/AdminDashboardPage';
import AdminStatsPage from './pages/AdminStatsPage';
import AssrHubPage from './pages/AssrHubPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminLivretPage from './pages/AdminLivretPage';
import { TeacherDashboardPage, TeacherStudentPage } from './pages/TeacherPages';
import TeacherCoursesHubPage from './pages/TeacherCoursesHubPage';
import TutosPage from './pages/TutosPage';
import RessourcesElevePage from './pages/RessourcesElevePage';
import CoursInteractifsPage from './pages/CoursInteractifsPage';
import DemosInteractivesPage from './pages/DemosInteractivesPage';
import OutilViewerPage from './pages/OutilViewerPage';
import CoursVoitureElevePage from './pages/CoursVoitureElevePage';
import ProgressionPage from './pages/ProgressionPage';
import FormationParcoursPage from './pages/FormationParcoursPage';
import ExamenBlancElevePage from './pages/ExamenBlancElevePage';
import BilansCompetencesPage from './pages/BilansCompetencesPage';
import RessourceFichePage from './pages/RessourceFichePage';
import InfractionsSanctionsPage from './pages/InfractionsSanctionsPage';
import ExamenBlancGrille31Page from './pages/ExamenBlancGrille31Page';
import CoursEnSallePage from './pages/CoursEnSallePage';
import RvpLandingPage from './pages/RvpLandingPage';
import RvpPresentationPage from './pages/RvpPresentationPage';
import RvpPublicView from './pages/RvpPublicView';
import RvpMirePage from './pages/RvpMirePage';
import ConduiteAccompagneeAacPage from './pages/ConduiteAccompagneeAacPage';
import ConduiteSuperviseePage from './pages/ConduiteSuperviseePage';
import RvpQuizPage from './pages/RvpQuizPage';
import SimulateurAlcoolPage from './pages/SimulateurAlcoolPage';
import SessionEleveRvpPage from './pages/SessionEleveRvpPage';
import ModulesConduiteLandingPage from './pages/ModulesConduiteLandingPage';
import ModuleChaineCinematiquePage from './pages/ModuleChaineCinematiquePage';
import RvpVotePage from './pages/RvpVotePage';
import OnisrMai2026Page from './pages/OnisrMai2026Page';
import SimulateursPage from './pages/SimulateursPage';
import AProposPage from './pages/AProposPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import FAQPage from './pages/FAQPage';
import GlossaireECSRPage from './pages/GlossaireECSRPage';
import SignalerErreurPage from './pages/SignalerErreurPage';
import NosPlateformesPage from './pages/NosPlateformesPage';
import Permis125Page from './pages/Permis125Page';
import MobileBottomNav from './components/MobileBottomNav';
import StudentDashboardPage from './pages/StudentDashboardPage';
import SalleSeancePage from './pages/SalleSeancePage';
import TeacherSeancesPage from './pages/TeacherSeancesPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PWAInstallBanner from './components/PWAInstallBanner';
import SallePreviewPage from './pages/SallePreviewPage';
import ScrollToTop from './components/ScrollToTop';
import JoinTeacherPage from './pages/JoinTeacherPage';
import NewSessionSheetPage from './pages/NewSessionSheetPage';
import SessionSheetPublicPage from './pages/SessionSheetPublicPage';
import TeacherSheetsListPage from './pages/TeacherSheetsListPage';
import ExamenBlancPublicPage from './pages/ExamenBlancPublicPage';
import PublicFlashSeancePage from './pages/PublicFlashSeancePage';
import AdminActuPage from './pages/AdminActuPage';
import DemandeInfoPage from './pages/DemandeInfoPage';
import AdminDemandesPage from './pages/AdminDemandesPage';
import AdminInboxPage from './pages/AdminInboxPage';
import TeacherMessagesPage from './pages/TeacherMessagesPage';
import StudentMessagesPage from './pages/StudentMessagesPage';
import GuideAacElevePage from './pages/GuideAacElevePage';
import SecretariatDashboardPage from './pages/SecretariatDashboardPage';
import SecretariatPlanningPage from './pages/SecretariatPlanningPage';
import SecretariatElevesPage from './pages/SecretariatElevesPage';
import SecretariatEnseignantsPage from './pages/SecretariatEnseignantsPage';
import SecretariatDsrPage from './pages/SecretariatDsrPage';
import SecretariatImportPage from './pages/SecretariatImportPage';
import MyPlanningPage from './pages/MyPlanningPage';
import RvpCastPublicView from './pages/RvpCastPublicView';
import RvpJoinPage from './pages/RvpJoinPage';
import CoursEnVoiturePage from './pages/CoursEnVoiturePage';
import BilanReprisePublicPage from './pages/BilanReprisePublicPage';
import MotoHomePage from './pages/MotoHomePage';
import MotoMagazinePage from './pages/MotoMagazinePage';
import MotoEtmPage from './pages/MotoEtmPage';
import MotoArticlePage from './pages/MotoArticlePage';
import MotoSatellitePage from './pages/MotoSatellitePage';
import MotoPlateauPage from './pages/MotoPlateauPage';
import MotoLivretPage from './pages/MotoLivretPage';
import TeacherFichesPlateauPage from './pages/TeacherFichesPlateauPage';
import LivretAmPage from './pages/LivretAmPage';
import LivretAMLecteur from './pages/LivretAMLecteur';
import AnnuairePage from './pages/AnnuairePage';
import PremierDepartHome from './pages/premier-depart/PremierDepartHome';
import PremierDepartChapitre from './pages/premier-depart/PremierDepartChapitre';
import PremierDepartEvaluation from './pages/premier-depart/PremierDepartEvaluation';
import AutoEcolesHub from './pages/auto-ecoles/AutoEcolesHub';
import AutoEcolesDept from './pages/auto-ecoles/AutoEcolesDept';
import AutoEcolesVille from './pages/auto-ecoles/AutoEcolesVille';
import AutoEcoleGerer from './pages/auto-ecoles/AutoEcoleGerer';
import OppositionConfirmer from './pages/auto-ecoles/OppositionConfirmer';
import MentionsAnnuaire from './pages/auto-ecoles/MentionsAnnuaire';
import AdminAnnuaire from './pages/admin/AnnuaireAdmin';
import AdminShell from './pages/AdminShell';
import AdminExportPage from './pages/AdminExportPage';
import AnalyseGiratoirePage from './pages/AnalyseGiratoirePage';
import StopCedezPage from './pages/StopCedezPage';
import IntersectionsPrioritePage from './pages/IntersectionsPrioritePage';
import ShortsPage from './pages/ShortsPage';
import ProposerShortPage from './pages/ProposerShortPage';
import VideosGalleryPage from './pages/VideosGalleryPage';
import ConditionsVideosPage from './pages/ConditionsVideosPage';
import MesShortsPage from './pages/MesShortsPage';
import ShortsModerationAdmin from './pages/admin/ShortsModerationAdmin';
import VCardPage from './pages/VCardPage';
import { isMotoHost } from './data/motoUnivers';

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    if (!location.pathname.startsWith('/admin')) api.trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  useEffect(() => {
    document.title = 'CodeVoiture.fr — Réussir le Code et la conduite (gratuit, ECSR)';
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <PageTracker />
        <Routes>
          <Route path="/" element={isMotoHost() ? <MotoHomePage /> : <HomePage />} />
          <Route path="/moto" element={<MotoHomePage />} />
          <Route path="/moto/enquetes" element={<MotoMagazinePage />} />
          <Route path="/moto/enquete/:slug" element={<MotoArticlePage kind="enquete" />} />
          <Route path="/moto/apprendre" element={<MotoEtmPage />} />
          <Route path="/moto/apprendre/:slug" element={<MotoArticlePage kind="dossier" />} />
          <Route path="/moto/apprendre/:parentSlug/:satelliteSlug" element={<MotoSatellitePage />} />
          <Route path="/moto/plateau" element={<MotoPlateauPage />} />
          <Route path="/moto/livret" element={<MotoLivretPage />} />
          <Route path="/livret-am/lecteur" element={<LivretAMLecteur />} />
          <Route path="/livret-am" element={<LivretAmPage />} />
          <Route path="/annuaire" element={<AnnuairePage />} />
          <Route path="/mon-premier-depart" element={<PremierDepartHome />} />
          <Route path="/mon-premier-depart/evaluation-finale" element={<PremierDepartEvaluation />} />
          <Route path="/mon-premier-depart/:dossierId/:slug" element={<PremierDepartChapitre />} />
          <Route path="/annuaire/opposition/confirmer" element={<OppositionConfirmer />} />
          <Route path="/mentions-annuaire" element={<MentionsAnnuaire />} />
          <Route path="/auto-ecoles" element={<AutoEcolesHub />} />
          <Route path="/auto-ecoles/:dept" element={<AutoEcolesDept />} />
          <Route path="/auto-ecoles/:dept/:villeSlug" element={<AutoEcolesVille />} />
          <Route path="/auto-ecoles/:dept/:villeSlug/:schoolId/gerer" element={<AutoEcoleGerer />} />
          <Route path="/s/:token" element={<PublicFlashSeancePage />} />
          <Route path="/eleve" element={<ElevePage />} />
          <Route path="/assr" element={<AssrHubPage />} />
          <Route path="/enseignant" element={<EnseignantPage />} />
          <Route path="/enseignant/dashboard" element={<TeacherDashboardPage />} />
          <Route path="/enseignant/mes-cours" element={<TeacherCoursesHubPage />} />
          <Route path="/enseignant/messages" element={<TeacherMessagesPage />} />
          <Route path="/messages" element={<StudentMessagesPage />} />
          <Route path="/cours/eleve/guide-aac" element={<GuideAacElevePage />} />
          <Route path="/secretariat" element={<SecretariatDashboardPage />} />
          <Route path="/secretariat/planning" element={<SecretariatPlanningPage />} />
          <Route path="/secretariat/eleves" element={<SecretariatElevesPage />} />
          <Route path="/secretariat/enseignants" element={<SecretariatEnseignantsPage />} />
          <Route path="/secretariat/dsr" element={<SecretariatDsrPage />} />
          <Route path="/secretariat/import" element={<SecretariatImportPage />} />
          <Route path="/mon-planning" element={<MyPlanningPage />} />
          <Route path="/enseignant/planning" element={<MyPlanningPage />} />
          <Route path="/enseignant/eleve/:id" element={<TeacherStudentPage />} />
          <Route path="/livret" element={<LivretPage />} />
          <Route path="/tutos" element={<TutosPage />} />
          <Route path="/ressources" element={<RessourcesElevePage />} />
          <Route path="/ressources/:slug" element={<RessourceFichePage />} />
          <Route path="/cours-interactifs" element={<CoursInteractifsPage />} />
          <Route path="/cours/analyse-giratoire" element={<AnalyseGiratoirePage />} />
          <Route path="/cours/stop-cedez" element={<StopCedezPage />} />
          <Route path="/cours/intersections-priorite" element={<IntersectionsPrioritePage />} />
          <Route path="/shorts" element={<ShortsPage />} />
          <Route path="/shorts/proposer" element={<ProposerShortPage />} />
          <Route path="/videos" element={<VideosGalleryPage />} />
          <Route path="/videos/conditions" element={<ConditionsVideosPage />} />
          <Route path="/eleve/mes-shorts" element={<MesShortsPage />} />
          <Route path="/enseignant/mes-shorts" element={<MesShortsPage />} />
          <Route path="/admin/shorts" element={<AdminShell><ShortsModerationAdmin /></AdminShell>} />
          <Route path="/vcard" element={<VCardPage />} />
          <Route path="/demos-interactives" element={<DemosInteractivesPage />} />
          <Route path="/cours/eleve/voiture" element={<CoursVoitureElevePage />} />
          <Route path="/cours/progression" element={<ProgressionPage />} />
          <Route path="/formation/parcours" element={<FormationParcoursPage />} />
          <Route path="/cours/eleve/examen-blanc" element={<ExamenBlancElevePage />} />
          <Route path="/cours/eleve/bilans" element={<BilansCompetencesPage />} />
          <Route path="/cours/eleve/infractions-sanctions" element={<InfractionsSanctionsPage />} />
          <Route path="/enseignant/examen-blanc-grille" element={<ExamenBlancGrille31Page />} />
          <Route path="/enseignant/cours-en-salle" element={<CoursEnSallePage />} />
          <Route path="/enseignant/fiches-plateau" element={<TeacherFichesPlateauPage />} />
          <Route path="/enseignant/rendez-vous-pedagogiques" element={<RvpLandingPage />} />
          <Route path="/formation/conduite-accompagnee-aac" element={<ConduiteAccompagneeAacPage />} />
          <Route path="/formation/conduite-supervisee" element={<ConduiteSuperviseePage />} />
          <Route path="/quiz/rvp/:slug" element={<RvpQuizPage />} />
          <Route path="/simulateur-alcool" element={<SimulateurAlcoolPage />} />
          <Route path="/seance/:slug" element={<SessionEleveRvpPage />} />
          <Route path="/modules-conduite" element={<ModulesConduiteLandingPage />} />
          <Route path="/modules-conduite/chaine-cinematique" element={<ModuleChaineCinematiquePage />} />
          <Route path="/enseignant/rendez-vous-pedagogiques/mire" element={<RvpMirePage />} />
          <Route path="/enseignant/rendez-vous-pedagogiques/:slug" element={<RvpPresentationPage />} />
          <Route path="/enseignant/rendez-vous-pedagogiques/:slug/vitrine" element={<RvpPublicView />} />
          <Route path="/vote/:session/:slug/:qIndex" element={<RvpVotePage />} />
          <Route path="/onisr-mai-2026" element={<OnisrMai2026Page />} />
          <Route path="/onisr" element={<OnisrMai2026Page />} />
          <Route path="/simulateurs" element={<SimulateursPage />} />
          <Route path="/a-propos" element={<AProposPage />} />
          <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
          <Route path="/rgpd" element={<MentionsLegalesPage />} />
          <Route path="/confidentialite" element={<MentionsLegalesPage />} />
          <Route path="/cookies" element={<MentionsLegalesPage />} />
          <Route path="/cgu" element={<MentionsLegalesPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/signaler-erreur" element={<SignalerErreurPage />} />
          <Route path="/nos-plateformes" element={<NosPlateformesPage />} />
          <Route path="/permis-125" element={<Permis125Page />} />
          <Route path="/glossaire" element={<GlossaireECSRPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/outil/:slug" element={<OutilViewerPage />} />
          <Route path="/revisions" element={<MagazineIndexPage />} />
          <Route path="/magazine" element={<MagazineIndexPage />} />
          <Route path="/magazine/:slug" element={<ArticlePage />} />
          <Route path="/admin" element={<AdminDashboardPage />} />
          <Route path="/admin/annuaire" element={<AdminShell><AdminAnnuaire /></AdminShell>} />
          <Route path="/admin/export" element={<AdminExportPage />} />
          <Route path="/admin/stats" element={<AdminStatsPage />} />
          <Route path="/admin/users" element={<AdminUsersPage />} />
          <Route path="/admin/livret" element={<AdminLivretPage />} />
          <Route path="/admin/actu" element={<AdminActuPage />} />
          <Route path="/admin/demandes" element={<AdminDemandesPage />} />
          <Route path="/admin/inbox" element={<AdminInboxPage />} />
          <Route path="/demande-info" element={<DemandeInfoPage />} />
          <Route path="/contact" element={<DemandeInfoPage />} />
          <Route path="/present/live/:code" element={<RvpCastPublicView />} />
          <Route path="/rvp/rejoindre/:code" element={<RvpJoinPage />} />
          <Route path="/enseignant/cours-en-voiture" element={<CoursEnVoiturePage />} />
          <Route path="/admin/articles" element={<AdminArticlesList />} />
          <Route path="/admin/articles/new" element={<AdminArticleEditor />} />
          <Route path="/admin/articles/:id" element={<AdminArticleEditor />} />
          <Route path="/eleve/dashboard" element={<StudentDashboardPage />} />
          <Route path="/enseignant/seances" element={<TeacherSeancesPage />} />
          <Route path="/enseignant/seance/:id" element={<SalleSeancePage />} />
          <Route path="/enseignant/apercu/:templateId" element={<SallePreviewPage />} />
          <Route path="/rejoindre" element={<JoinTeacherPage />} />
          <Route path="/enseignant/fiches" element={<TeacherSheetsListPage />} />
          <Route path="/enseignant/fiche-seance/nouvelle" element={<NewSessionSheetPage />} />
          <Route path="/fiche/:token" element={<SessionSheetPublicPage />} />
          <Route path="/examen-blanc/:token" element={<ExamenBlancPublicPage />} />
          <Route path="/bilan/:token" element={<BilanReprisePublicPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <AuthModal />
        <Toaster theme="dark" position="top-center" richColors closeButton toastOptions={{ style: { background: '#141416', border: '1px solid rgba(255,255,255,0.12)', color: '#fff' } }} />
        <MobileBottomNav />
        <PWAInstallBanner />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
